<template>
  <div class="login-container">
    <div class="login-card">
      <div class="logo-container">
        <img alt="公司Logo" src="@/assets/company-logo.jpg" class="logo" />
        <h1>人事档案-绩效考核-培训</h1>
      </div>

      <div class="login-tabs">
        <button
          :class="['tab-btn', activeTab === 'account' ? 'active' : '']"
          @click="activeTab = 'account'"
        >
          账号登录
        </button>
        <button
          :class="['tab-btn', activeTab === 'captcha' ? 'active' : '']"
          @click="activeTab = 'captcha'"
        >
          验证码登录
        </button>
      </div>

      <form @submit.prevent="handleLogin" class="login-form">
        <!-- 账号登录表单 -->
        <div v-if="activeTab === 'account'" class="form-content">
          <div class="form-row">
            <div class="form-group">
              <div class="label-container">
                <span class="label-first-char">用</span>
                <span class="label-rest-chars">户名</span>
              </div>
              <input
                type="text"
                v-model="username"
                placeholder="请输入用户名"
                required
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <div class="label-container">
                <span class="label-first-char">密</span>
                <span class="label-rest-chars">码</span>
              </div>
              <input
                type="password"
                v-model="password"
                placeholder="请输入密码"
                required
                class="form-input"
              />
            </div>
          </div>
        </div>

        <!-- 验证码登录表单 -->
        <div v-else class="form-content">
          <div class="form-row">
            <div class="form-group">
              <div class="label-container">
                <span class="label-first-char">手</span>
                <span class="label-rest-chars">机号</span>
              </div>
              <input
                type="text"
                v-model="phone"
                placeholder="请输入手机号"
                required
                class="form-input"
              />
            </div>
          </div>

          <div class="form-row">
            <div class="form-group">
              <div class="label-container">
                <span class="label-first-char">验</span>
                <span class="label-rest-chars">证码</span>
              </div>
              <div class="captcha-input-group">
                <input
                  type="text"
                  v-model="captcha"
                  placeholder="请输入验证码"
                  required
                  class="form-input captcha-input"
                />
                <button
                  type="button"
                  class="captcha-btn"
                  :disabled="countdown > 0"
                  @click="sendCaptcha"
                >
                  {{ countdown > 0 ? `${countdown}s后重试` : "获取验证码" }}
                </button>
              </div>
            </div>
          </div>
        </div>

        <button type="submit" class="login-btn">
          {{ activeTab === "account" ? "登录" : "验证码登录" }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
import { loginMixin } from "@/mixins/loginMixin";
import { syncUserUpvotes as syncUserUpvotesApi } from "@/request/dingtalk_request";
import { get } from "lodash";
import { isNavigationFailure, NavigationFailureType } from "vue-router";

// axios已在main.js中全局配置，使用this.$http代替直接导入的axios

export default {
  name: "LoginPage",
  mixins: [loginMixin],
  data() {
    return {
      activeTab: "account",
      username: "",
      password: "",
      phone: "",
      captcha: "",
      loading: false,
      countdown: 0,
      role: "",
      token: "",
      userNumber: "",
      timer: null,
    };
  },
  methods: {
    // 清理登录信息的方法
    clearLoginInfo() {
      // 清除对方登录方式的信息
      if (this.activeTab === "account") {
        // 账号登录时，清除验证码登录的信息（由user store处理）
      } else {
        // 验证码登录时，清除账号登录的信息（由user store处理）
      }
    },
    async handleLogin() {
      // 登录前先清理对方的登录信息
      this.clearLoginInfo();
      if (this.activeTab === "account") {
        if (!this.username || !this.password) {
          this.$message.error("请输入用户名和密码");
          return;
        }
        this.loading = true;
        try {
          // 创建普通JavaScript对象来发送JSON格式的请求
          const params = {
            name: this.username, // 使用name参数
            password: this.password,
          };

          // 记录完整的请求信息用于调试
          const loginUrl = "/login";
          console.log("===== 开始账号登录请求 =====");
          console.log("请求URL:", loginUrl);
          console.log("请求基础URL(baseURL):", this.$http.defaults.baseURL);
          console.log(
            "最终请求URL(组合后):",
            this.$http.defaults.baseURL + loginUrl,
          );
          console.log("请求参数:", {
            username: this.username,
            password: this.password,
          });
          console.log("原始参数对象:", params);
          console.log("请求配置:", {
            withCredentials: true,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/json",
            },
          });

          // 修复路径问题：由于axios已配置baseURL为'/api'，且后端Controller类也有/api前缀，这里只需使用/login
          const response = await this.$http
            .post(loginUrl, params, {
              withCredentials: true,
              headers: {
                "X-Requested-With": "XMLHttpRequest",
                "Content-Type": "application/json",
              },
            })
            .catch((error) => {
              console.log("===== 登录请求错误详情 =====");
              console.log("loginUrl地址:", loginUrl);
              console.log("错误类型:", error.name);
              console.log("错误状态码:", error.response?.status);
              console.log("错误响应数据:", error.response?.data);
              console.log("完整错误对象:", error);
              throw error;
            });

          if (String(response.data.code) === "200") {
            // 账号登录成功，存储账号信息
            // 从响应数据中获取role字段
            const responseData = response.data;
            const userNumber = responseData.data.user.number;
            const userRole = responseData.data.role; // 从data字段获取role
            const token = responseData.data.token;
            const jobLevel = responseData.data.user.jobLevel;
            const userId = get(responseData, ["data", "user", "id"]);

            this.setLoginInfo({
              role: userRole,
              token,
              userId: userId,
              userNumber,
              userName: this.username,
              jobLevel,
            });
            this.$message.success("登录成功");

            // 登录成功后同步用户点赞数据
            this.syncUserUpvotes(userId);

            // 更健壮的路由检查，避免重复导航错误
            try {
              // 检查路径而非名称，避免路由名称冲突
              if (!this.$route.path.includes("/employee-list")) {
                this.$router
                  .push({ path: "/employee-list" })
                  .catch((failure) => {
                    if (
                      isNavigationFailure(
                        failure,
                        NavigationFailureType.redirected,
                      )
                    ) {
                      // TODO: 重定向提示信息？
                    }
                  });
              }
            } catch (error) {
              console.log("路由跳转错误已捕获:", error.message);
              // 忽略重复导航错误
            }
          } else {
            this.$message.error(
              response.data?.message || "登录失败，请检查用户名和密码",
            );
          }
        } catch (error) {
          if (error.response) {
            this.$message.error(error.response.data.message || "登录失败");
          } else if (error.request) {
            this.$message.error("网络连接异常");
          } else {
            this.$message.error("请求配置错误");
          }
        } finally {
          this.loading = false;
        }
      } else {
        console.log("验证码登录:", {
          phone: this.phone,
          captcha: this.captcha,
        });

        // 验证码登录逻辑
        if (!this.phone || !this.captcha) {
          this.$message.error("请输入手机号和验证码");
          return;
        }

        this.loading = true;
        try {
          // 创建URLSearchParams对象来发送表单格式的请求
          const params = new URLSearchParams();
          params.append("phone", this.phone);
          params.append("verifyCode", this.captcha);

          // 记录完整的请求信息用于调试
          const loginUrl = "/login/phone";
          console.log("===== 开始验证码登录请求 =====");
          console.log("请求URL:", loginUrl);
          console.log("请求基础URL(baseURL):", this.$http.defaults.baseURL);
          console.log(
            "最终请求URL(组合后):",
            this.$http.defaults.baseURL + loginUrl,
          );
          console.log("请求参数:", { phone: this.phone, verifyCode: "******" });
          console.log("原始参数对象:", params);
          console.log("请求配置:", {
            withCredentials: true,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });

          // 调用服务端验证码登录接口，修复路径问题
          const response = await this.$http.post(loginUrl, params, {
            withCredentials: true,
            headers: {
              "X-Requested-With": "XMLHttpRequest",
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });

          // 根据服务端接口响应结构处理
          if (response.data.success) {
            // 验证码登录成功，存储手机号信息
            const userRole = response.data.data.role; // 从data字段获取role
            const token = response.data.data.token;
            const jobLevel = response.data.data.user?.jobLevel;
            const userId = response.data.data.user?.id || null;

            // 使用user store存储用户信息
            this.$store.dispatch('user/setCurrentUser', {
              id: userId,
              name: '',
              number: '',
              role: userRole,
              jobLevel: jobLevel,
              token: token,
              phone: this.phone
            });

            console.log("token:", token);
            console.log("用户角色2:", userRole);
            this.$message.success(response.data.message || "登录成功");
            // 存储token到sessionStorage
            if (response.data.data && response.data.data.token) {
              window.sessionStorage.setItem("token", response.data.data.token);
            }

            // 登录成功后同步用户点赞数据
            this.syncUserUpvotes(userId);

            // 更健壮的路由检查，避免重复导航错误
            try {
              // 检查路径而非名称，避免路由名称冲突
              if (!this.$route.path.includes("/employee-list")) {
                this.$router.push({ path: "/employee-list" });
              }
            } catch (error) {
              console.log("路由跳转错误已捕获:", error.message);
              // 忽略重复导航错误
            }
          } else {
            this.$message.error(response.data.message || "手机号或验证码错误");
          }
        } catch (error) {
          if (error.response) {
            this.$message.error(
              error.response.data.message || "登录失败，请检查验证码",
            );
          } else if (error.request) {
            this.$message.error("网络连接异常");
          } else {
            this.$message.error("请求配置错误");
          }
        } finally {
          this.loading = false;
        }
      }
    },
    // 显示消息
    // 显示消息
    showMessage(msg, type = "success") {
      this.message = msg;
      this.messageType = type;
      setTimeout(() => {
        this.message = "";
      }, 3000);
    },

    // 发送验证码
    async sendCaptcha() {
      if (!this.phone) {
        this.showMessage("请输入手机号", "error");
        return;
      }

      // 手机号格式验证
      const phoneRegex = /^1[3-9]\d{9}$/;
      if (!phoneRegex.test(this.phone)) {
        this.showMessage("请输入正确的手机号", "error");
        return;
      }

      this.loading = true;

      try {
        // 创建URLSearchParams对象来发送表单格式的请求
        const params = new URLSearchParams();
        params.append("phone", this.phone);

        // 记录完整的请求信息用于调试
        const sendCodeUrl = "/sms/send-code";
        console.log("===== 开始发送验证码请求 =====");
        console.log("请求URL:", sendCodeUrl);
        console.log("请求基础URL(baseURL):", this.$http.defaults.baseURL);
        console.log(
          "最终请求URL(组合后):",
          this.$http.defaults.baseURL + sendCodeUrl,
        );
        console.log("请求参数:", { phone: this.phone });
        console.log("原始参数对象:", params);
        console.log("请求配置:", {
          withCredentials: true,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        // 修复路径问题，与其他登录请求保持一致
        await this.$http.post(sendCodeUrl, params, {
          withCredentials: true,
          headers: {
            "X-Requested-With": "XMLHttpRequest",
            "Content-Type": "application/x-www-form-urlencoded",
          },
        });

        this.showMessage("验证码发送成功", "success");

        // 开始倒计时
        this.countdown = 60;
        this.timer = setInterval(() => {
          this.countdown--;
          if (this.countdown <= 0) {
            clearInterval(this.timer);
          }
        }, 1000);
      } catch (error) {
        console.error("发送验证码失败:", error);
        this.showMessage("验证码发送失败，请稍后重试", "error");
      } finally {
        this.loading = false;
      }
    },

    // 同步用户点赞数据
    async syncUserUpvotes(userId) {
      if (!userId) {
        console.log("用户ID为空，跳过同步点赞数据");
        return;
      }

      try {
        console.log("===== 开始同步用户点赞数据 =====");
        console.log("用户ID:", userId);

        const response = await syncUserUpvotesApi({ userId });

        if (String(response.data.code) === "200" || response.data.code === 200) {
          const syncedCount = response.data.data?.synced || 0;
          const syncStatus = response.data.data?.status || "";
          console.log(`点赞数据同步完成，同步了 ${syncedCount} 条记录，状态: ${syncStatus}`);
          // 仅在同步成功且有数据时显示提示
          if (syncedCount > 0 && syncStatus === "SUCCESS") {
            console.log(`已同步 ${syncedCount} 条点赞数据`);
          }
        } else {
          console.warn("点赞数据同步响应异常:", response.data);
        }
      } catch (error) {
        // 同步失败不影响登录流程，仅记录日志
        console.error("同步用户点赞数据失败:", error.response?.data?.message || error.message);
      }
    },
  },

  beforeUnmount() {
    if (this.timer) {
      clearInterval(this.timer);
    }
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.login-card {
  background: white;
  padding: 2.5rem;
  border-radius: 12px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
}

.logo-container {
  text-align: center;
  margin-bottom: 2rem;
}

.logo {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  object-fit: contain;
}

h1 {
  color: #2c3e50;
  font-size: 1.5rem;
  margin: 0;
}

.login-tabs {
  display: flex;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid #e2e8f0;
}

.tab-btn {
  flex: 1;
  padding: 0.75rem;
  background: none;
  border: none;
  font-size: 1rem;
  font-weight: 500;
  color: #718096;
  cursor: pointer;
  position: relative;
}

.tab-btn.active {
  color: #4299e1;
}

.tab-btn.active::after {
  content: "";
  position: absolute;
  bottom: -1px;
  left: 0;
  right: 0;
  height: 2px;
  background-color: #4299e1;
}

.form-row {
  margin-bottom: 1.5rem;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.label-container {
  display: flex;
  margin-bottom: 0.5rem;
}

.label-first-char {
  font-weight: 500;
  color: #4a5568;
  width: 1em;
  text-align: right;
  margin-right: 0.2em;
}

.label-rest-chars {
  font-weight: 500;
  color: #4a5568;
}

.form-input {
  padding: 0.75rem;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  font-size: 1rem;
  transition: border-color 0.2s;
  width: 100%;
  box-sizing: border-box;
}

.form-input:focus {
  outline: none;
  border-color: #4299e1;
}

.captcha-input-group {
  display: flex;
  gap: 0.5rem;
}

.captcha-input {
  flex: 1;
}

.captcha-btn {
  padding: 0 1rem;
  background-color: #f7fafc;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  color: #4299e1;
  font-size: 0.875rem;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.2s;
}

.captcha-btn:hover:not(:disabled) {
  background-color: #ebf8ff;
}

.captcha-btn:disabled {
  color: #a0aec0;
  cursor: not-allowed;
}

.login-btn {
  background-color: #4299e1;
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 6px;
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s;
  width: 100%;
  margin-top: 0.5rem;
}

.login-btn:hover {
  background-color: #3182ce;
}
</style>
